import { useApplication } from "./application";
import { useApplicationPageMutation } from "./aggregatedData";
export function useSendApplicationAction() {
  var _useApplication = useApplication(),
    application = _useApplication.application;
  var _useApplicationPageMu = useApplicationPageMutation(function (request) {
      return {
        method: 'POST',
        url: "/awa/v1/applications/".concat(application.id, "/actions"),
        body: {
          data: {
            type: 'application_action',
            attributes: request
          }
        }
      };
    }),
    mutate = _useApplicationPageMu.mutate,
    status = _useApplicationPageMu.status;
  return {
    sendApplicationAction: mutate,
    sendApplicationStatus: status
  };
}